import { createFileRoute } from "@tanstack/react-router";

import { LabsPage } from "@/features/clinical/LabsPage";

export const Route = createFileRoute("/_app/labs")({
  component: LabsPage,
});
